import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  OrderformProductItem,
  OrderformSelectedPlanQuantityDiscount,
} from '@orderform/widgets';
import { OrderformFascade } from '../../../fascades/orderform.fascade';
import { filter, map, switchMap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'orderform-quantity-discount',
  templateUrl: './quantity-discount.component.html',
  styleUrls: ['./quantity-discount.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuantityDiscountComponent implements OnInit {
  private _productId$ = new BehaviorSubject<number>(null);

  @Input() set productId(productId: number) {
    this._productId$.next(productId);
  }

  discounts$: Observable<OrderformSelectedPlanQuantityDiscount[]> =
    this._orderformFascade.selectedPlan$.pipe(
      map((data) => {
        return data.quantity_discounts;
      })
    );

  productData$: Observable<OrderformProductItem> = this._productId$.pipe(
    filter((productId) => !!productId),
    switchMap((productId) => {
      return this._orderformFascade.settings$.pipe(
        map((settings) => {
          return settings.product.items.find(
            (p) => +p.product_id === +productId
          );
        })
      );
    })
  );

  quantityDiscountHtmlByProductId$: Observable<{
    [productId: number]: {
      table: string;
      label: string;
      active: boolean;
    };
  }> = this.discounts$.pipe(
    map((unsortedList) => {
      return (unsortedList || []).reduce((obj, item) => {
        obj[item.product_id] = {
          table: item.html,
          label: item.label,
          active: item.type === 'discount_applied',
        };
        return obj;
      }, {});
    })
  );

  constructor(private _orderformFascade: OrderformFascade) {}

  ngOnInit(): void {}
}
